export enum salesOrdersTypes {
  GET_ORDERS_DEFINITIONS = '@@salesOrders/GET_ORDERS_DEFINITIONS',
  GET_SALE_ORDERS_SUCCESS = '@@salesOrders/GET_SALES_ORDERS_SUCCESS',
  GET_SALE_ORDERS_FAIL = '@@salesOrders/GET_SALES_ORDERS_FAIL',

  GET_MILESTONESCONFIG_SO = "@SO/GET_MILESTONECONFIG",
  GET_MILESTONESCONFIG_SO_SUCCESSS = "@SO/GET_MILESTONECONFIG_SUCCESS",
  GET_MILESTONESCONFIG_SO_FAIL = "@SO/GET_MILESTONECONFIG_FAIL"
}
